import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

import { UserService } from "../../../services/user.service";
import { ProviderService } from "../../../services/provider.service";

const Desactivate = (props) => {
  let name = props.type === "employee" ? "empleado(s)" : "proveedor(es)";
  const handleClose = () => {
    props.onClose();
  };

  const handleAccept = () => {
    props.onClose();
    switch (props.type) {
      case "employee":
        deleteEmployee(props.userSelected);

        break;

      case "provider":
        deleteProvider(props.userSelected);
        break;

      default:
        break;
    }
  };

  const deleteEmployee = () => {
    UserService.deleteUser(props.userSelected)
      .then((response) => {
        if (response.status === 200) props.isUserDeleted(true);
      })
      .catch((error) => {
        console.log(error);
        props.isUserDeleted(false);
      });
  };

  const deleteProvider = () => {
    ProviderService.deleteProvider(props.userSelected)
      .then((response) => {
        if (response.status === 200) props.isUserDeleted(true);
      })
      .catch((error) => {
        console.log(error);
        props.isUserDeleted(false);
      });
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={true}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogTitle id="alert-dialog-slide-description">
            <span>¿Estas seguro de eliminar el {name} ?</span>
          </DialogTitle>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            style={{ marginRight: 50, width: 150 }}
            onClick={handleClose}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleAccept}
            color="primary"
            style={{ width: 150 }}
            variant="contained"
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default Desactivate;
